module.exports = __webpack_public_path__ + "img/rafaed.117348bb.gif";